<div class="container">
  <div class="heading">
    <h3 class="list-heading"><i class="fa-solid fa-sitemap"></i> {{ hierarchyName }}</h3>
  </div>
  <button (click)="goBack()" class="toggle-button small-button">All Hierarchies</button>
  &nbsp;
  <button (click)="toggleView()" class="toggle-button small-button">Toggle View</button>
  &nbsp;
  <button *ngIf="showGraph" (click)="changeOrientation()" class="toggle-button small-button">
    Change Orientation
  </button>
  <br>

  <div *ngIf="showModal" class="cl-modal-container">
    <div class="cl-modal">
      <div class="cl-modal-header">
        <h3>Add Classification</h3>
      </div>
      <div class="cl-modal-content">
        <form>
          <div class="cl-input-container">
            <label for="selectTerm">Select Term:</label>
            <select id="selectTerm" name="selectTerm" [(ngModel)]="selectedTerm">
              <option value="" disabled selected>Select Term</option>
              <option *ngFor="let term of terms" [value]="term">{{ term }}</option>
            </select>
          </div>

          <div class="cl-input-container">
            <label for="enterCode">Enter Code:</label>
            <input type="text" id="enterCode" name="enterCode" [(ngModel)]="newClassificationCode">
          </div>

          <div class="cl-input-container">
            <label for="enterValue">Enter Value:</label>
            <input type="text" id="enterValue" name="enterValue" [(ngModel)]="newClassificationValue">
          </div>

          <div class="cl-input-container">
            <label for="selectType">Select Type:</label>
            <select id="selectType" name="selectType" [(ngModel)]="selectedType" disabled>
              <!-- <option value="AV">AV</option> -->
              <option value="HIER">HIER</option>
            </select>
          </div>

          <div class="cl-button-container">
            <button type="button" class="save-button" (click)="saveClassification()">Save</button>
            &nbsp;
            <button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div *ngIf="!showGraph">
    <mat-tree class="matTree" [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle (dragstart)="onDragStart(node, 'hierarchy')">
        <div class="mat-tree-node nodetree" draggable="true" (dragover)="onDragOver($event)"
          (drop)="onDrop($event, node, 'hierarchy')"
          [ngClass]="{'parent-node': node.cur_tr != hierarchyTermName, 'child-node': node.cur_tr == hierarchyTermName}">

          <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle *ngIf="hasChild(0, node)"
            [attr.aria-label]="'Toggle ' + node.name">
            {{treeControl.isExpanded(node) ? 'remove' : 'add'}}

          </mat-icon>

          <div *ngIf="node.cur_tr == hierarchyTermName">
            <svg height="20px" width="20px" viewBox="0 0 512 512" xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 512 512">
              <path
                d="M423.4 358c-43.8-6.7-47.1-13.1-47.1-13.1 9-54.1-18.9-122.6-64.6-159.7-60.7-49.3-153.1-13.5-225-88.5-16.8-17.5-7 196.3 83 277.3 65.8 59.2 143.3 41 164.6 31.3 19.3-8.8 32.8-24.9 32.8-24.9 35.1 10.8 52.5 10.2 52.5 10.2 12.3 1.5 18.5-30.4 3.8-32.6zm-80.2 3.6c-115.3-34.1-202-153.8-202-153.8s76.1 89.8 210.2 133.5c.2 6.8-3.8 16.5-8.2 20.3z"
                fill="#00ff2f" class="fill-000000"></path>
            </svg>
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;{{node.name}}&nbsp;<span>({{node.code}})</span>
          <div class="custom-dropdown" (click)="setSelectedNode(node)">

            <mat-icon *ngIf="!(node.isRoot && node.cur_tr==hierarchyTermName)"
              (click)="unattachFromParent(node, 'hierarchy')" class="close-icon" matTooltip="Remove from hierarchy">
              close</mat-icon>


            <mat-icon class="trash-icon" *ngIf="(node.cur_tr==hierarchyTermName)" matTooltip="Delete classification"
              (click)="deleteclassification(node,'hierarchy')">
              delete</mat-icon>

          </div>
        </div>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" draggable="true"
        (dragstart)="onDragStart(node, 'hierarchy')">
        <div class="mat-tree-node nodetree" (dragover)="onDragOver($event)" (drop)="onDrop($event, node, 'hierarchy')"
        [ngClass]="{'parent-node': node.cur_tr != hierarchyTermName, 'child-node': node.cur_tr == hierarchyTermName}">
          <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle *ngIf="hasChild(0, node)"
            [attr.aria-label]="'Toggle ' + node.name">
            {{treeControl.isExpanded(node) ? 'remove' : 'add'}}

          </mat-icon>
          <div *ngIf="node.cur_tr == hierarchyTermName">
            <svg height="20px" width="20px" viewBox="0 0 512 512" xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 512 512">
              <path
                d="M423.4 358c-43.8-6.7-47.1-13.1-47.1-13.1 9-54.1-18.9-122.6-64.6-159.7-60.7-49.3-153.1-13.5-225-88.5-16.8-17.5-7 196.3 83 277.3 65.8 59.2 143.3 41 164.6 31.3 19.3-8.8 32.8-24.9 32.8-24.9 35.1 10.8 52.5 10.2 52.5 10.2 12.3 1.5 18.5-30.4 3.8-32.6zm-80.2 3.6c-115.3-34.1-202-153.8-202-153.8s76.1 89.8 210.2 133.5c.2 6.8-3.8 16.5-8.2 20.3z"
                fill="#00ff2f" class="fill-000000"></path>
            </svg>
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;{{node.name}}&nbsp;<span>({{node.code}})</span>
          <div class="custom-dropdown" (click)="setSelectedNode(node)">

            <mat-icon *ngIf="!(node.isRoot && node.cur_tr==hierarchyTermName)"
              (click)="unattachFromParent(node, 'hierarchy')" class="close-icon" matTooltip="Remove from hierarchy">
              close</mat-icon>


            <mat-icon class="trash-icon" *ngIf="(node.cur_tr==hierarchyTermName)" matTooltip="Delete classification"
              (click)="deleteclassification(node)">
              delete</mat-icon>

          </div>
        </div>
        <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
    <div (dragover)="onDragOver($event)" (drop)="onDrop($event, null, 'canvas')" class="canvas">

    </div>

  </div>

  <div class="right-box">
    <!-- *ngIf="!showGraph"  -->
    <div class="dropdown">
      <label for="dropdown1">Term:</label><br>
      <select id="dropdown1" name="term" (change)="onTermChange()" [(ngModel)]="selectedTerm">
        <option value="" disabled selected>Select Term</option>
        <option *ngFor="let term of terms" [value]="term">{{ term }}</option>
      </select>&nbsp;

    </div>
    <div class="dropdown">
      <label for="dropdown2">Classification:</label><br>
      <!-- <select id="dropdown2" name="value" (change)="onValueChange($event)" [(ngModel)]="selectedClassification">
                <option value="" disabled selected>Select Value</option>
                classifications
                <option *ngFor="let cl of classifications" [value]="cl">{{ cl }}</option>
            </select> -->
      <input type="text" placeholder="Filter Classification" [(ngModel)]="filterText" class="filter-input">
      <br><br><br>
      <div class="scrollable-content">
        <div *ngIf="selectedTerm">
          
          <div *ngFor="let cl of filterClassifications()">
            <div (dragstart)="onDragStart(cl, 'rightbox')" draggable="true" (dragover)="onDragOver($event)">
              <mat-icon style="vertical-align: middle;">add</mat-icon>&nbsp;
              <!-- <mat-icon style="vertical-align: middle;">chevron_right</mat-icon>&nbsp; -->
              {{ cl?.cl_cd }} ({{cl.cl_val}})
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="selectedClassification" class="selected-classification">
                <div *ngFor="let classificationData of classificationsData"
                    (click)="setSelectedNode(classificationData)">
                    <div *ngIf="selectedClassification === classificationData.cl_cd"
                        (dragstart)="onDragStart(classificationData, 'rightbox')" draggable="true"
                        (dragover)="onDragOver($event)">
                        <mat-icon style="vertical-align: middle;">chevron_right</mat-icon>&nbsp;
                        {{classificationData.cl_val }} ({{selectedClassification }})
                    </div>
                </div>
            </div> -->
    </div>
  </div>

  <div *ngIf="showGraph">
    <ngx-graph [links]="getFilteredLinks()" [nodes]="getFilteredNodes()" [view]="[1250, 550]" [autoCenter]="true"
      [layout]="'dagre'" [layoutSettings]="layoutSettings">
      <!-- [showMiniMap]="true" -->
      <ng-template #defsTemplate>
        <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
          <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
        </svg:marker>
      </ng-template>

      <ng-template #clusterTemplate let-cluster>
        <svg:g class="node cluster">
          <svg:rect rx="5" ry="5" [attr.width]="cluster.dimension.width" [attr.height]="cluster.dimension.height"
            [attr.fill]="cluster.data.color" />
        </svg:g>
      </ng-template>

      <ng-template #nodeTemplate let-node>
        <svg:g class="node" draggable="true" (mousedown)="onMouseDown($event, node)" (mousemove)="onMouseMove($event)"
          (mouseup)="onMouseUp($event, node)" [attr.data-node-id]="node.id" (dragstart)="onDragStart(node, 'graph')"
          (dragover)="onDragOver($event)" (drop)="onDrop($event, node, 'graph')">

          <svg:rect width="80" height="30" [attr.fill]="node.data.color" />

          <svg:text alignment-baseline="middle" [attr.x]="10" [attr.y]="20">
            <title>{{ node.label }}</title>
            <tspan *ngIf="node.label.length <= 9" x="10" text-anchor="start">{{ node.label }}</tspan>
            <tspan *ngIf="node.label.length > 9" text-anchor="start" [attr.x]="10">
              {{ (node.label | slice:0:9) + '...' }}
            </tspan>
          </svg:text>

          <foreignObject *ngIf="!isRootNode(node.id) || (isRootNode(node.id) && isToggled(node.id))" [attr.x]="80"
            [attr.y]="0" width="20" height="30">
            <!-- *ngIf="!node.isRoot" -->

            <body xmlns="http://www.w3.org/1999/xhtml">

              <button (click)="unattachFromParent(node, 'graph')" [ngClass]="getButtonClass(node.id)"
                style="display: flex; justify-content: center; align-items: center; padding: 0; background-color: #e64560;"
                class="node-button" (mousedown)="$event.stopPropagation()" (mouseup)="$event.stopPropagation()">
                <div>
                  <mat-icon class="mat-icon-rtl-mirror">
                    close
                  </mat-icon>
                </div>
              </button>
            </body>
          </foreignObject>

          <foreignObject *ngIf="!isRootNode(node.id) || (isRootNode(node.id) && isToggled(node.id))"
            [attr.x]="calculateSecondForeignObjectX(node)" [attr.y]="calculateSecondForeignObjectY(node)" width="20"
            height="30">

            <body xmlns="http://www.w3.org/1999/xhtml">

              <button (click)="toggleConnectedNodes(node.id)" [ngClass]="getButtonClass(node.id)"
                style="display: flex; justify-content: center; align-items: center; padding: 0;" class="node-button"
                (mousedown)="$event.stopPropagation()" (mouseup)="$event.stopPropagation()">
                <div>
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{ getChevronIcon(node.id) }}
                  </mat-icon>
                </div>
              </button>
            </body>
          </foreignObject>
        </svg:g>
      </ng-template>

      <ng-template #linkTemplate let-link>
        <svg:g class="edge">
          <svg:path class="line" stroke-width="2" marker-end="url(#arrow)">
          </svg:path>
          <svg:text class="edge-label" text-anchor="middle">
            <textPath class="text-path" [attr.href]="'#' + link.id" [style.dominant-baseline]="link.dominantBaseline"
              startOffset="50%">
              {{link.label}}
            </textPath>
          </svg:text>
        </svg:g>
      </ng-template>
    </ngx-graph>
  </div>

</div>
